module.exports = __webpack_public_path__ + "static/media/soma1.c8b027f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ParkingLots/Instructions/SF/soma1.png
// module id = 2217
// module chunks = 0